module.exports = __webpack_public_path__ + "static/media/fondo-nuevo-home-hoteles.b89a0194.webp";